export const mapErrors = (errors = []) => {
  const mappedErrors = errors.map((error) => ({
    ...transformErrorToObject(error)
  }));
  return mappedErrors || [];
};

/**
 * Transforms an error message string into an object with `name` and `value` properties.
 *
 * This function takes a string in the format of "Key: value", splits it at the first
 * occurrence of ": ", and returns an object where the `name` is the key converted to
 * lowercase, and the `value` is everything after the colon.
 *
 * @param {string} error - The error message string to be transformed.
 * @returns {Object} An object with `name` and `value` properties.
 * @property {string} name - The key from the error message, converted to lowercase.
 * @property {string} value - The value from the error message.
 *
 * @example
 * // Returns { name: 'email', value: 'has already been taken' }
 * transformErrorToObject('Email: has already been taken');
 */
const transformErrorToObject = (error) => {
  const [key, value] = error.split(": ", 2);
  const keyInLowerCase = String(key).toLowerCase();
  return {
    name: keyInLowerCase,
    value
  };
};
